import { serializeError } from "serialize-error";
import { v4 as uuid } from "uuid";
import mapValues from "lodash/mapValues";
import { apiFetch } from "./api-fetch";

const sessionId = uuid();

const mapBody = (input: Record<string, unknown>) => {
  if (typeof input !== "object") return input;
  if (!input) return input; // null is an object
  return mapValues(input, (v: any): unknown => {
    if (v instanceof Error) {
      return serializeError(v);
    }
    if (v && typeof v === "object") {
      return mapBody(v);
    }
    return v;
  });
};

export const reportInfo = (body: Record<string, unknown>) => {
  apiFetch("/api/log-entries/info", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...mapBody(body), sessionId }),
  }).catch(() => {
    // Don't throw error to avoid infinite circular loop
  });
};

export const formatError = (err: any) =>
  err instanceof Error
    ? `${err.toString()}\n${err.message}\n${err.stack}`
    : "" + err;

export const reportError = (body: Record<string, unknown>) => {
  console.log("Report error");
  apiFetch("/api/log-entries/errors", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...mapBody(body), sessionId }),
  })
    .catch(() => {
      console.error("Report error to backend failed");
      // Don't throw error to avoid infinite circular loop
    })
    .finally(() => {
      console.log("Report error done");
    });
};

export const reportWarning = (body: Record<string, unknown>) => {
  apiFetch("/api/log-entries/warnings", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...mapBody(body), sessionId }),
  }).catch(() => {
    // Don't throw error to avoid infinite circular loop
  });
};
